import {
  object,
  string
} from "yup";

import "./schemas";

const notableEventIncidentSchema = object({
  notes: string()
    .trim()
    .required()
    .label("Notes")
});

export default notableEventIncidentSchema;
